import {SUBSCRIPTION_HEALTH, type SubscriptionHealthType
} from '../constants/subscriptionHealth';

export function getSubscriptionHealthLabel(
  health: SubscriptionHealthType
): string {

  switch (health) {

    case SUBSCRIPTION_HEALTH.HEALTHY:
      return 'Saudável';

    case SUBSCRIPTION_HEALTH.WARNING:
      return 'Expirando';

    case SUBSCRIPTION_HEALTH.EXPIRED:
      return 'Expirada';

    case SUBSCRIPTION_HEALTH.PENDING:
      return 'Pendente';

    case SUBSCRIPTION_HEALTH.SUSPENDED:
      return 'Suspenso';

    case SUBSCRIPTION_HEALTH.BLOCKED:
      return 'Bloqueado';

    default:
      return 'Desconhecido';
  }
}

export function getSubscriptionHealthColor(
  health: SubscriptionHealthType
): string {

  switch (health) {

    case SUBSCRIPTION_HEALTH.HEALTHY:
      return 'text-green-400';

    case SUBSCRIPTION_HEALTH.WARNING:
      return 'text-yellow-400';

    case SUBSCRIPTION_HEALTH.EXPIRED:
      return 'text-red-400';

    case SUBSCRIPTION_HEALTH.PENDING:
      return 'text-blue-400';

    case SUBSCRIPTION_HEALTH.SUSPENDED:
      return 'text-orange-400';

    case SUBSCRIPTION_HEALTH.BLOCKED:
      return 'text-red-500';

    default:
      return 'text-slate-400';
  }
}

export function getSubscriptionHealthBadge(
  health: SubscriptionHealthType
): string {

  switch (health) {

    case SUBSCRIPTION_HEALTH.HEALTHY:
      return '🟢';

    case SUBSCRIPTION_HEALTH.WARNING:
      return '🟡';

    case SUBSCRIPTION_HEALTH.EXPIRED:
      return '🔴';

    case SUBSCRIPTION_HEALTH.PENDING:
      return '🔵';

    case SUBSCRIPTION_HEALTH.SUSPENDED:
      return '🟠';

    case SUBSCRIPTION_HEALTH.BLOCKED:
      return '⚫';

    default:
      return '⚪';
  }
}